import { ApplicationAttachmentType } from '~domain/model/application/attachment/application-attachment';

export const CommonImages = {
  policies: {
    productTypeIcon: {
      car: '/img/common/product-type-icon-car.svg',
      home: '/img/common/product-type-icon-home.svg',
    },
    modificationOptions: {
      address: '/img/common/policy-modification/address.svg',
      addReplaceRemoveCar: '/img/common/policy-modification/add-replace-remove-car.svg',
      bankingInformation: '/img/common/policy-modification/banking-information.svg',
      cancellation: '/img/common/policy-modification/cancellation.svg',
      claims: '/img/common/policy-modification/claims.svg',
      coInsured: '/img/common/policy-modification/co-insured.svg',
      contactInformation: '/img/common/policy-modification/contact-information.svg',
      help: '/img/common/policy-modification/help.svg',
      occasionalDrivers: '/img/common/policy-modification/occasional-drivers.svg',
      requestPolicyCopy: '/img/common/policy-modification/request-policy-copy.svg',
    },
    attachmentCategories: {
      schedule: '/img/common/calendar.png',
      billing: '/img/common/billing.png',
      contract: '/img/common/contract.png',
      certificate: '/img/common/certification.png',
      general: '/img/common/document.png',
      debug: '/img/common/debug.png',
    },
  },
  applications: {
    attachmentTypes: {
      [ApplicationAttachmentType.DashDriverReport]: '/img/common/driver.png',
    } satisfies Record<ApplicationAttachmentType, string>,
  },
  misc: {
    gift: '/img/common/gift.svg',
  },
  map: {
    marker: '/img/common/map-marker.svg',
  },
};
